/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Studio_Stat_SourceInputs */

const en_ui_studio_stat_source = /** @type {(inputs: Ui_Studio_Stat_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source file`)
};

const de_ui_studio_stat_source = /** @type {(inputs: Ui_Studio_Stat_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelldatei`)
};

/**
* | output |
* | --- |
* | "Source file" |
*
* @param {Ui_Studio_Stat_SourceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_studio_stat_source = /** @type {((inputs?: Ui_Studio_Stat_SourceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Studio_Stat_SourceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_studio_stat_source(inputs)
	return de_ui_studio_stat_source(inputs)
});